import { manageBugsnagUser } from './bugsnag';
import { initialize as initDispatcher } from './dispatcher';
import { manageFullStory } from './fullstory';
import { startWebVitalsAnalytics } from './web-vitals';

export const initialize = async () => {
  await Promise.all([initDispatcher(), manageFullStory(), manageBugsnagUser()]);
  startWebVitalsAnalytics();
};
